import useSWR from 'swr';
import { FilterState } from 'components/DataTable/DataTable';

/** One month bucket of a timeseries; the value keys differ per endpoint. */
export interface TimeseriesBucket {
    month: number;
    [key: string]: number;
}

interface TimeseriesResponse {
    months?: TimeseriesBucket[];
}

/**
 * Load a monthly accounting timeseries. The endpoints share the DataTable filter blob,
 * so the chart can be driven by exactly the same filter state as the table beside it.
 */
export const useAccountingTimeseries = (
    url: string | null,
    filter?: FilterState,
    params: Record<string, string | undefined> = {}
) => {
    // Undefined extras must not become the string "undefined" in the query. Only undefined
    // is dropped, never an empty string: that is the key of the "no cost centre" bucket,
    // and filtering it out would silently widen the chart back to every cost centre.
    const extra = Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined));

    const { data, isLoading } = useSWR<TimeseriesResponse>(
        url ? [url, { filter: filter ?? {}, ...extra }] : null
    );

    return {
        months: data?.months ?? [],
        isLoading
    };
};

export default useAccountingTimeseries;
